import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import ImageView from '../../../image-view';
import LibraryEmail from '../../../library-email';
import img from '../../../../assets/t-406/kosmos.jpg';
import imgPreview from '../../../../assets/t-406/kosmos-small.jpg';
import './style.scss';
import DownloadButton from '../../../download-button';

type Props = {
    onComplete?: () => void
}

const Task406: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-406');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-406">
        <h2>zadanie 6</h2>
        <h3>{task?.title}</h3>
        <p>
            Jednym z elementów, które wzmacnia czytanie, jest kreatywność! Jest wiele książek i czasopism, które uczą tworzenia rzeczy, czyli DIY (z angielskiego <span style={{ fontStyle: 'italic' }}>do it yourself</span> - zrób to sam).
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> na podstawie poniżej zamieszczonej instrukcji stwórzcie tubę i wykrzyczcie przez nią co, według Was, jest wzmacniane dzięki czytaniu! Nagrajcie się i wyślijcie video na adres e-mail swojej biblioteki.
        </p>
        <LibraryEmail />
        <p>
            Instrukcję tę przygotował dla Was "Kosmos dla dziewczynek"
        </p>
        <div className="image">
            <ImageView src={imgPreview} preview={imgPreview} />
            <DownloadButton src={img} file='tuba.jpg' />
        </div>
    </div>
}

export default Task406;
